import Image from "next/image";

import { TeamMemberProps } from "@/types";

import styles from "@/app/about-us/page.module.css";

export default function TeamMember({ image, name, institution }: TeamMemberProps) {
  return (
    <div className={`col position-relative ${styles.memberWrapper}`}>
      <div className={`text-center p-4 ${styles.memberContent}`}>
        <div className="d-flex flex-column align-items-center">
          <Image
            src={image?.url || "/images/about-us/default-avatar.jpg"}
            alt={`${name}'s profile`}
            className={`rounded-circle img-fluid mb-3 g2-team-member-image ${styles.teamMemberImage}`}
            width={120}
            height={120}
          />
          <h5 className="fw-medium mb-2 g2-text-grey">{name}</h5>
          <p className="mb-0 g2-text-grey">{institution}</p>
        </div>
      </div>
    </div>
  );
}
